import React, {StrictMode} from 'react';
import ReactDOM from 'react-dom/client';
import '@emotion/react/jsx-runtime';

if (import.meta.env.DEV) {
  await import('@emotion/react/jsx-dev-runtime');
}
import reportWebVitals from '@/reportWebVitals';
import {injectGlobal} from '@emotion/css';

import Auth0ProviderWithRedirect from "@/Auth0ProviderWithRedirect";
import {CarecoApiContextProvider} from "@/app-context/careco-api-context-provider";
import {QueryClientProvider} from "@tanstack/react-query";
import App, {queryClient} from "@/App";
import {globalStyles} from "@/styles";
import "@/federation";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

injectGlobal(globalStyles);

root.render(
  <StrictMode>
    <Auth0ProviderWithRedirect
      cacheLocation="localstorage"
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/login`,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: "read:current_user profile role:admin role:user",
      }}
    >
      <QueryClientProvider client={queryClient}>
        <CarecoApiContextProvider>
          <App />
        </CarecoApiContextProvider>
      </QueryClientProvider>
    </Auth0ProviderWithRedirect>
  </StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
